<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
  <g id="Group_2103" data-name="Group 2103" transform="translate(-16 -45)">
    <rect id="Rectangle_144" data-name="Rectangle 144" width="28" height="28" transform="translate(16 45)" fill="#fff" opacity="0"/>
    <path id="Path_2" data-name="Path 2" d="M0,6.443,6.443,0l6.443,6.443" transform="translate(25.701 64.943) rotate(-90)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
  </g>
</svg>
